<template>
  <div class="container">
    <form action="/">
      <van-search placeholder="请输入搜索关键词" shape="round" @click="onClickInput" />
    </form>
    <div v-if="showEmpty==false">
      <van-tree-select
        height="84.5vh"
        :items="items"
        :active-id.sync="activeId"
        :main-active-index.sync="activeIndex"
        @click-nav="onClickNav"
        style="border-top: 1px solid #DFDFDF;"
      >
        <template slot="content" v-if="items[activeIndex]!=null">
          <div class="image">
            <van-image :src="items[activeIndex].imageUrl" />
          </div>
          <!-- <van-divider
            :style="{ color: '#333', borderColor: '#333', padding: '0 20%' }"
          >{{items[activeIndex].text}}</van-divider>-->
          <van-cell
            :title="items[activeIndex].text"
            value="全部"
            is-link
            title-style="font-weight:bold;font-size:4vw;"
            value-class="total"
            @click="clickCategoryAll(items[activeIndex].id)"
          />
          <van-grid
            v-if="items[activeIndex]!=null"
            square
            :column-num="3"
            :border="false"
            gutter="10"
          >
            <van-grid-item
              v-for="item in items[activeIndex].children"
              :key="item.id"
              @click="clickCategory(items[activeIndex].id,item.id)"
            >
              <van-image :src="item.imageUrl" fit="fill" />
              <div style="height:6vw;line-height:6vw;font-size:3.2vw">{{item.text}}</div>
            </van-grid-item>
          </van-grid>
        </template>
      </van-tree-select>
    </div>

    <div v-else class="index-empty">
      <div style="height:40%">商家很懒，没有任何商品</div>
    </div>
  </div>
</template>
<script>
import { TreeSelect, Image, Grid, GridItem, Divider, Search, Cell } from "vant";
import service from "../../api/group/index";
export default {
  components: {
    [TreeSelect.name]: TreeSelect,
    [Image.name]: Image,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Divider.name]: Divider,
    [Search.name]: Search,
    [Cell.name]: Cell
  },
  data() {
    return {
      showEmpty: false,
      items: [],
      activeId: 1,
      activeIndex: 0
    };
  },
  methods: {
    init() {
      service
        .get()
        .then(response => {
          let tData = [];
          response.data.map(function(item, index) {
            tData.push({
              id: item.code,
              text: item.name,
              imageUrl: item.imageUrl,
              children: [],
              dot: false
            });
            if (index == 0 && item.goodsGroupChildren) {
              item.goodsGroupChildren.map(child => {
                tData[0].children.push({
                  id: child.code,
                  text: child.name,
                  dot: false,
                  imageUrl: child.imageUrl
                  // itemList:child.goodsGroupItem
                });
              });
            }
          });
          this.items = tData;
          //   this.items = response.data;
        })
        .catch(error => {
          if (error.status == 404) {
            this.showEmpty = true;
          }
        });
    },
    clickCategoryAll(item) {
      this.$router.push({ name: "groupList", query: { id: item } });
    },
    clickCategory(id, code) {
      this.$router.push({
        name: "groupChildList",
        query: { id: id, code: code }
      });
    },
    onClickInput() {
      this.$router.push("/search");
    },
    onClickNav(index) {
      // let id = this.items[index].code;
      // service
      //   .get(id)
      //   .then(response => {
      //     let tData = [];
      //     response.data.map(child => {
      //       tData.push({
      //         id: child.code,
      //         imageUrl: child.imageUrl,
      //         text: child.name,
      //         dot: false
      //       });
      //     });
      //     this.items[index].children = tData;
      //   })
      //   .catch(error => {
      //     if (error.status == 404) {
      //       // this.showEmpty = true;
      //     }
      //   });
      service
        .get()
        .then(response => {
          let tData = [];
          response.data.map(function(item, index) {
            tData.push({
              id: item.code,
              text: item.name,
              imageUrl: item.imageUrl,
              children: [],
              dot: false
            });
            if (index + 1 == item.sort && item.goodsGroupChildren) {
              item.goodsGroupChildren.map(child => {
                tData[index].children.push({
                  id: child.code,
                  text: child.name,
                  dot: false,
                  imageUrl: child.imageUrl
                });
              });
            }
          });
          this.items = tData;
          //   this.items = response.data;
        })
        .catch(error => {
          if (error.status == 404) {
            this.showEmpty = true;
          }
        });
    }
  },
  mounted() {
    this.init();
  }
  // beforeRouteEnter(to, from, next) {
  //   service
  //     .get()
  //     .then(response => {
  //       let tData = [];
  //       response.data.map(function(item, index) {
  //         tData.push({
  //           id: item.id,
  //           text: item.name,
  //           imageUrl: item.imageUrl,
  //           children: [],
  //           dot: false
  //         });
  //         if (index == 0 && item.goodsGroupChildren) {
  //           item.goodsGroupChildren.map(child => {
  //             tData[0].children.push({
  //               id: child.id,
  //               text: child.name,
  //               dot: false,
  //               imageUrl: child.imageUrl
  //             });
  //           });
  //         }
  //       });

  //       next(vm => {
  //         if (response.data == "") {
  //           // vm.showEmpty = true;
  //         } else {
  //           vm.items = tData;
  //         }
  //       });
  //     })
  //     .catch(error => {
  //       if (error.status == 404) {
  //         next(vm => {
  //           // vm.showEmpty = true;
  //         });
  //       }
  //     });
  // }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  .van-tree-select__nav {
    border-right: 1px solid #dfdfdf;
    background-color: #fff;
  }
}
.image {
  width: 58vw;
  height: 24vw;
  margin: 10px auto;
}
.index {
  &-empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border-top: 1px solid #f4f4f4;
  }
}
.van-sidebar-item--select::before {
  width: 0.8vw;
  height: 8vw;
}
.van-sidebar-item--select,
.van-sidebar-item--select:active {
  color: #ee0a24;
}
.van-tree-select__nav-item {
  padding: 7vw 2vw 7vw 3vw;
  background-color: #fff;
  font-weight: bold;
}
.van-cell__right-icon {
  font-size: 12px;
}
.total {
  font-size: 12px;
}
</style>